import React from "react";
import { CalendarDensity, CalendarMode } from "../";
import { DropDownMenu, DropDownMenuGroup, DropDownMenuItem } from "../DropDownMenu";

const calendarModeLabels: Record<CalendarMode, string> = {
  day: "Day",
  week: "Week",
};

type Props = {
  calendarMode: CalendarMode;
  declinedEvents: boolean;
  density: CalendarDensity;
  onCalendarDensityChange: (density: CalendarDensity) => void;
  onCalendarModeChange: (view: CalendarMode) => void;
  onShowDeclinedEventsChange: (showDeclinedEvents: boolean) => void;
  onShowHoldsChange: (collapse: boolean) => void;
  onShowWeekendsChange: (showWeekends: boolean) => void;
  showHolds: boolean;
  weekends: boolean;
};

export const CalendarMenu = ({
  calendarMode,
  declinedEvents,
  density,
  onCalendarDensityChange,
  onCalendarModeChange,
  onShowDeclinedEventsChange,
  onShowHoldsChange,
  onShowWeekendsChange,
  showHolds,
  weekends,
}: Props) => {
  return (
    <DropDownMenu
      label={calendarModeLabels[calendarMode]}
      maxHeight="320px"
      size="small"
      variant="default"
    >
      <DropDownMenuItem onClick={() => onCalendarModeChange("day")}>Day</DropDownMenuItem>
      <DropDownMenuItem onClick={() => onCalendarModeChange("week")}>Week</DropDownMenuItem>
      <DropDownMenuGroup label="View settings">
        <DropDownMenuItem onClick={() => onShowWeekendsChange(!weekends)} checked={weekends}>
          Show weekends
        </DropDownMenuItem>
        <DropDownMenuItem
          onClick={() => onShowDeclinedEventsChange(!declinedEvents)}
          checked={declinedEvents}
        >
          Show declined events
        </DropDownMenuItem>
        <DropDownMenuItem onClick={() => onShowHoldsChange(!showHolds)} checked={showHolds}>
          Show Focus Time
        </DropDownMenuItem>
      </DropDownMenuGroup>
      <DropDownMenuGroup label="Density">
        <DropDownMenuItem
          onClick={() => onCalendarDensityChange("compact")}
          checked={density === "compact"}
        >
          Compact
        </DropDownMenuItem>
        <DropDownMenuItem
          onClick={() => onCalendarDensityChange("default")}
          checked={density === "default"}
        >
          Default
        </DropDownMenuItem>
        <DropDownMenuItem
          onClick={() => onCalendarDensityChange("comfortable")}
          checked={density === "comfortable"}
        >
          Comfortable
        </DropDownMenuItem>
      </DropDownMenuGroup>
    </DropDownMenu>
  );
};
